import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import { EviProgress } from '~/eds/src/components/EviProgress/EviProgress';
import { useIntl } from 'react-intl';
import { slices } from '~/redux/slices';

const ProgressBar = () => {
  const intl = useIntl();
  const model = useSelector(slices.automation.selectors.selectAutomationModel);
  const progress = model?.progress || {};

  if (isEmpty(progress)) return null;

  return (
    <EviProgress
      activeStage={progress.active}
      stages={[
        {
          title: intl.formatMessage({
            id: 'ProgressBar.step1Title',
            defaultMessage: 'Step 1',
            description: 'Title for step 1 in progress bar',
          }),
          description: intl.formatMessage({
            id: 'ProgressBar.trainDescription',
            defaultMessage: 'Train',
            description: 'Description for training step in progress bar',
          }),
          steps: progress.stages[0],
        },
        {
          title: intl.formatMessage({
            id: 'ProgressBar.step2Title',
            defaultMessage: 'Step 2',
            description: 'Title for step 2 in progress bar',
          }),
          steps: [],
          ...progress.stages[1],
        },
        {
          title: intl.formatMessage({
            id: 'ProgressBar.step3Title',
            defaultMessage: 'Step 3',
            description: 'Title for step 3 in progress bar',
          }),
          steps: [],
          ...progress.stages[2],
        },
      ]}
    />
  );
};

export default ProgressBar;
